module.exports = __webpack_public_path__ + "bg-login.svg?d5d5e157bbedabbc91d98ff8994d906e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg-login.svg
// module id = 270
// module chunks = 2